<template>
  <div class="container-1200" style="margin: 80px 0px;">
    <h1 class="text-center">Create a new workshop</h1>
    <div class="container-750">
      <div class="first-row">
        <h6>Course/Workshop Title</h6>
        <input type="text" v-model="model.name" />
        <!--        <h6>Trainer's short description</h6>-->
        <!--        <textarea name="" id="" cols="25" rows="9" class="text-are" placeholder="Type message"></textarea>-->

        <!--        <h6>Course/Workshop Title</h6>-->
        <!--        <input type="text">-->

        <!--        <h6>Objective</h6>-->
        <!--        <input type="text">-->

        <!--        <h6>Course Outline: Class 1</h6>-->
        <!--        <input type="text">-->

        <!--        <h6>Course Outline: Class 2</h6>-->
        <!--        <input type="text">-->
        <!--        <btn-->
        <!--            color="transparent"-->
        <!--            textcolor="#1000A9"-->
        <!--            mode="outline"-->
        <!--            class="red-outlined-1"-->
        <!--        >-->
        <!--          add more class-->
        <!--        </btn>-->
      </div>
      <div class="second-row">
        <div class="d-flex" style="justify-content: space-between">
          <div>
            <h6>Upload Course Outline</h6>
            <u-photo-upload
              type="outline"
              @uploaded="addOutline"
            ></u-photo-upload>
          </div>
          <div>
            <h6>Upload High Resolution Photo</h6>
            <u-photo-upload type="photo" @uploaded="addPhoto"></u-photo-upload>
          </div>
        </div>
      </div>
      <!--      <div class="second-row">-->
      <!--        -->
      <!--      </div>-->
      <div class="third-row">
        <label for="meeting-time" style="margin-top: 10px"
          >Set a workshop time proposal:</label
        >
        <input type="datetime-local" id="meeting-time" name="meeting-time" v-model="time"/>
      </div>
      <div class="text-center" style="margin-top:25px; margin-bottom:35px;">
        <btn
          color="#1000A9"
          textcolor="#1000A9"
          class="red-outlined text-center"
          @click.prevent.native="submitReview"
        >
          submit to review
        </btn>
      </div>
    </div>
  </div>
</template>

<script>
import btn from "./UButton";
export default {
  components: {
    btn
  },
  data() {
    return {
      time: "",
      model: {
        name: "name",
        course_outline: "course_outline",
        description: "description",
        category: "live",
        duration: 2,
        files: []
      }
    };
  },
  computed: {
    parseTime() {
      let d = new Date(this.time)
      return d.getTime() / 1000
    }
  },
  methods: {
    submitReview() {
      this.model.workshop_ts = this.parseTime
      this.$upskill.addWR(this.model).then(() => {
        this.$emit("submitted", "done")
      })
    },
    addOutline(e) {
      e.response.file_name = "Outline."+e.response.file_name.split(".")[1]
      this.model.files.push(e.response)
    },
    addPhoto(e) {
      e.response.file_name = "Photo."+e.response.file_name.split(".")[1]
      this.model.files.push(e.response)
    }
  },
  created() {
    this.Loaded();
  }
};
</script>

<style scoped>
.registration_next {
  border: 2px solid #1000a9;
  height: 44px;
  border-radius: 4px;
}

.registration_next:hover {
  color: #0062ff;
}

.red-outlined {
  border: 2px solid #1000a9;
  padding: 5px;
  width: 350px;
  color: white;
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
  letter-spacing: 2.8px;
  line-height: 29px;
  text-transform: uppercase;
  text-align: center;
}

.red-outlined-1 {
  padding: 5px;
  margin-left: 0;
  width: 250px;
  color: #1000a9;
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
  letter-spacing: 2.8px;
  line-height: 29px;
  text-transform: uppercase;
}

.bolder {
  font-family: "Open Sans", sans-serif;
  color: black;
  font-size: 14px;
  line-height: 22px;
}

.bolder span {
  font-family: "Open Sans", sans-serif;
  color: #1000a9;
  font-size: 14px;
  line-height: 22px;
  text-transform: uppercase;
  font-weight: bold;
}

h5 {
  font-family: "Open Sans", sans-serif;
  color: #728391;
  font-size: 14px;
  line-height: 22px;
}

h5 span {
  font-family: "Open Sans", sans-serif;
  color: #728391;
  font-size: 14px;
  line-height: 22px;
  font-weight: bold;
}

.text-are {
  background-color: #f8f8f9;
  width: 100%;
  border: 1px solid #728391;
}

textarea::-webkit-input-placeholder {
  padding: 25px;
  color: black;
  font-family: "Open Sans", sans-serif;
}

textarea:-moz-placeholder {
  /* Firefox 18- */
  padding: 25px;
  color: black;
  font-family: "Open Sans", sans-serif;
}

textarea::-moz-placeholder {
  /* Firefox 19+ */
  padding: 25px;
  color: black;
  font-family: "Open Sans", sans-serif;
}

textarea:-ms-input-placeholder {
  padding: 25px;
  color: black;
  font-family: "Open Sans", sans-serif;
}

textarea::placeholder {
  padding: 25px;
  color: black;
  font-family: "Open Sans", sans-serif;
}

h1 {
  font-family: "Monstserrat", sans-serif;
  color: #000000;
  font-size: 32px;
  line-height: 40px;
  font-weight: bold;
  letter-spacing: -0.8px;
  text-transform: uppercase;
  margin: 35px 0;
}

h6 {
  margin-top: 25px;
  font-family: "Monstserrat", sans-serif;
  color: #000000;
  font-size: 16px;
  line-height: 24px;
  font-weight: bold;
}

.third-row {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 2px 4px #0b2a5a33;
  border-radius: 10px;
  padding: 10px 20px;
  margin-bottom: 25px;
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.first-row {
  background-color: red;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 2px 4px #0b2a5a33;
  border-radius: 10px;
  padding: 10px 20px;
  margin-bottom: 25px;
}

.second-row {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 2px 4px #0b2a5a33;
  border-radius: 10px;
  padding: 10px 20px;
  margin-bottom: 25px;
}

input {
  width: 100%;
  background-color: #f8f8f9;
  border: 1px solid #728391;
  background: #f8f8f9 0% 0% no-repeat padding-box;
  height: 44px;
}

.image-border {
  background: #f8f8f9 0% 0% no-repeat padding-box;
  border: 1px solid #1000a9;
  border-radius: 4px;
  opacity: 1;
}

.img-border-container {
  margin: 0 auto;
  max-width: 400px;
  padding: 25px 0;
}
</style>
